import r from "@mapbox/mapbox-gl-draw";
import { PL_DIRECT_SELECT as a } from "./index.es445.js";
import { getDeckDrawFeature as f, isFabricObjOnTop as u } from "./index.es446.js";
const d = r.constants, o = r.lib, m = r.modes.simple_select, c = { ...m };
c.onTap = c.onClick = function(t, e) {
  const s = f(e);
  if (s && this.clickOnDeckFeature(t, e, s), o.CommonSelectors.noTarget(e))
    return this.clickAnywhere(t, e);
  if (o.CommonSelectors.isOfMetaType(d.meta.VERTEX)(e))
    return this.clickOnVertex(t, e);
  if (o.CommonSelectors.isFeature(e))
    return this.clickOnFeature(t, e);
};
c.clickAnywhere = function(t) {
  o.doubleClickZoom.enable(this), this.stopExtendedInteractions(t);
};
c.clickOnVertex = function(t, e) {
};
c.clickOnFeature = function(t, e) {
  if (u(e))
    return;
  o.doubleClickZoom.disable(this), this.stopExtendedInteractions(t);
  const s = this.getSelectedIds(), i = e.featureTarget.properties.id;
  this.isSelected(i) || (s.forEach((l) => this.doRender(l)), this.setSelected(i), this.changeMode(a, { featureId: i }), this.updateUIClasses({ mouse: d.cursors.MOVE })), this.doRender(i);
};
c.clickOnDeckFeature = function(t, e, s) {
  if (u(e))
    return;
  o.doubleClickZoom.disable(this), this.stopExtendedInteractions(t);
  const i = this.getSelectedIds(), n = s.object.id;
  this.isSelected(n) || (i.forEach((h) => this.doRender(h)), this.setSelected(n), this.changeMode(a, { featureId: n }), this.updateUIClasses({ mouse: d.cursors.MOVE })), this.doRender(n);
};
export {
  c as default
};
//# sourceMappingURL=index.es382.js.map
